var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"verification-iframe"},[_c('v-main',[(!_vm.loading)?_c('router-view',{staticClass:"router-view px-7",staticStyle:{"height":"100%"},attrs:{"id":"router-view"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }